// extracted by mini-css-extract-plugin
module.exports = {"root":"NOHEfficiencyLineChart_root__30Xdk","yUnitLabel":"NOHEfficiencyLineChart_yUnitLabel__humsY"};